"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var useInterval_1 = __importDefault(require("../../../lib/customHooks/useInterval"));
var react_1 = __importDefault(require("react"));
var config_1 = require("./config");
var TimerQueueWrapper = function (props) {
    var children = props.children, _a = props.intervalSeconds, intervalSeconds = _a === void 0 ? config_1.defaultIntervalSeconds : _a;
    var maxQueue = children.length - 1;
    var _b = useInterval_1.default({
        refreshCount: maxQueue,
        secondsPerStep: intervalSeconds
    }), timeNow = _b.timeNow, handleStopTime = _b.handleStopTime, handleStartTime = _b.handleStartTime;
    var mouseProps = {
        onMouseEnter: handleStopTime,
        onMouseLeave: handleStartTime,
    };
    var _children = react_1.default.Children.map(children, function (child, i) { return (react_1.default.cloneElement(child, mouseProps)); });
    return (react_1.default.createElement(react_1.default.Fragment, null, _children && _children[timeNow]));
};
exports.default = TimerQueueWrapper;
